import {
  FunctionalColorConfig,
  FunctionalColorToken,
  setTheme,
} from '@aries/ui-theming';

const colorFillContentHover = {
  dark: '#25304f',
  light: '#e4e4eb',
};
const colorDivider = {
  dark: '#14192a',
  light: '#f1f1f6',
};
const colorTextSubdued = {
  dark: '#9597a7',
  light: '#6b6b80',
};
const colorTextDisabled = {
  dark: '#434360',
  light: '#9ea0af',
};
const colorTextCritical = {
  dark: '#FF6966',
  light: '#FF6966',
};
const colorTextSuccess = {
  dark: '#66ffa4',
  light: '#66ffa4',
};
const colorTextWarning = {
  dark: '#fbbf24',
  light: '#fbbf24',
};
const colorTextHighlight = {
  dark: '#71ceff',
  light: '#626cf1',
};
const colorTextDecorative = {
  dark: '#0ea5e9',
  light: '#0ea5e9',
};
const colorTextLightSolid = {
  dark: '#ffffff',
  light: '#ffffff',
};
const colorIcon = {
  dark: '#9597a7',
  light: '#6b6b80',
};
const colorIconSuccess = {
  dark: '#22c55e',
  light: '#22c55e',
};
const colorIconWarning = {
  dark: '#fbbf24',
  light: '#fbbf24',
};
const colorIconCritical = {
  dark: '#f86868',
  light: '#f86868',
};
const colorIconHighlight = {
  dark: '#8293f8',
  light: '#626cf1',
};
const colorIconHover = {
  dark: '',
  light: '',
};
const colorSurfaceSubdued = {
  dark: '#0a0a19',
  light: '#f8f9fc',
};
const colorSurfaceSelected = {
  dark: '#5BA6CE30',
  light: '#f0f3ff',
};
const colorSurfaceHover = {
  dark: '#f1f1f6',
  light: '#272744',
};
const colorInteractive = {
  dark: '#71ceff',
  light: '#626cf1',
};
const colorBgHeader = {
  dark: '#0F131F',
  light: '',
};
const colorHeaderMenu = {
  dark: '#141929',
  light: '#fff',
};
const colorHeaderMenuActive = {
  dark: '#71CEFF',
  light: '',
};
const colorFormBg = {
  dark: 'rgba(178, 221, 254, 0.5)',
  light: 'rgba(178, 221, 254, 0.25)',
};
const colorBgFooter = {
  dark: '#0F131F',
  light: '#E2E6F3',
};
const colorBgDecorative = {
  dark: '#71CEFF',
  light: '#DBF7F7',
};
export const functionalColorConfig: FunctionalColorConfig = {
  colorInteractive,
  colorFillContentHover,
  colorDivider,
  colorTextSubdued,
  colorTextDisabled,
  colorTextSuccess,
  colorTextWarning,
  colorTextCritical,
  colorTextHighlight,
  colorTextDecorative,
  colorTextLightSolid,
  colorIcon,
  colorIconSuccess,
  colorIconWarning,
  colorIconCritical,
  colorIconHover,
  colorIconHighlight,
  colorSurfaceSubdued,
  colorSurfaceSelected,
  colorSurfaceHover,
  colorBgHeader,
  colorHeaderMenu,
  colorHeaderMenuActive,
  colorFormBg,
  colorBgFooter,
  colorBgDecorative,
};

export const functionalColorToken: FunctionalColorToken = {
  colorFillContentHover: setTheme(colorFillContentHover),
  colorDivider: setTheme(colorDivider),
  colorTextSubdued: setTheme(colorTextSubdued),
  colorTextDisabled: setTheme(colorTextDisabled),
  colorTextSuccess: setTheme(colorTextSuccess),
  colorTextWarning: setTheme(colorTextWarning),
  colorTextCritical: setTheme(colorTextCritical),
  colorTextHighlight: setTheme(colorTextHighlight),
  colorTextDecorative: setTheme(colorTextDecorative),
  colorTextLightSolid: setTheme(colorTextLightSolid),
  colorIcon: setTheme(colorIcon),
  colorIconSuccess: setTheme(colorIconSuccess),
  colorIconWarning: setTheme(colorIconWarning),
  colorIconCritical: setTheme(colorIconCritical),
  colorIconHover: setTheme(colorIconHover),
  colorIconHighlight: setTheme(colorIconHighlight),
  colorSurfaceSubdued: setTheme(colorSurfaceSubdued),
  colorSurfaceSelected: setTheme(colorSurfaceSelected),
  colorSurfaceHover: setTheme(colorSurfaceHover),
  colorInteractive: setTheme(colorInteractive),
  colorBgHeader: setTheme(colorBgHeader),
  colorHeaderMenu: setTheme(colorHeaderMenu),
  colorHeaderMenuActive: setTheme(colorHeaderMenuActive),
  colorFormBg: setTheme(colorFormBg),
  colorBgFooter: setTheme(colorBgFooter),
  colorBgDecorative: setTheme(colorBgDecorative),
};
